import { ResetLink } from '../../Header.styles';
import { AccountWrapper } from './AccountMenu.style';

const AccountMenu = () => (
    <AccountWrapper>
        <li>
            <ResetLink
                href="/favourites/properties/"
                data-testid="header-profilemenu-saved-listing"
                data-track-category="User Account"
                data-track-action="clickthrough"
                data-track-label="user account>favourite properties"
            >
                Saved listings
            </ResetLink>
        </li>
        <li>
            <ResetLink
                href="/favourites/tracked-properties/"
                data-testid="header-profilemenu-tracked-properties"
                data-track-category="User Account"
                data-track-action="clickthrough"
                data-track-label="user account>tracked properties"
            >
                Tracked properties
            </ResetLink>
        </li>
        <li>
            <ResetLink
                href="/myaccount/alerts-searches/"
                data-testid="header-profilemenu-alerts-searches"
                data-track-category="User Account"
                data-track-action="clickthrough"
                data-track-label="user account>alerts & searches"
            >
                Alerts and searches
            </ResetLink>
        </li>
        <li>
            <ResetLink
                href="/myaccount/account/preferences/"
                data-testid="header-profilemenu-email-preferences"
                data-track-category="User Account"
                data-track-action="clickthrough"
                data-track-label="user account>email preferences"
            >
                Email preferences
            </ResetLink>
        </li>
        <li>
            <ResetLink
                href="/myaccount/"
                data-testid="header-profilemenu-account"
                data-track-category="User Account"
                data-track-action="clickthrough"
                data-track-label="user account>manage account"
            >
                More account settings
            </ResetLink>
        </li>
        <li>
            <ResetLink
                href="/?signout=1"
                data-testid="header-profilemenu-sign-out"
                data-track-category="User Account"
                data-track-action="clickthrough"
                data-track-label="user account>sign out"
                data-ajax="false"
            >
                Sign out
            </ResetLink>
        </li>
    </AccountWrapper>
);

export default AccountMenu;
